export const VIEW_SAMPLE_PROJECT_USER_PROPERTY_KEY =
	'jira.onboarding.view.sample.project.cta.tenant.CLOUD_ID';

export const SAMPLE_PROJECT_SESSION_STORE_KEY = 'sampleProjectSessionStoreKey';

export const SAMPLE_PROJECT_CTA_PROPERTY = 'sampleProjectCtaProperty';
export const SAMPLE_PROJECT_NUDGES_PROPERTY = 'sampleProjectNudgesProperty';
export const SAMPLE_PROJECT_NAV_NUDGE_PROPERTY = 'sampleProjectNavNudgeProperty';

export type SampleProjectSessionKey =
	| typeof SAMPLE_PROJECT_CTA_PROPERTY
	| typeof SAMPLE_PROJECT_NUDGES_PROPERTY
	| typeof SAMPLE_PROJECT_NAV_NUDGE_PROPERTY;

// QUERY PARAMETER KEYS
export const TEMPLATE_CHOICE = 'template_choice';
export const TEAM_TYPE = 'tt';
// QUERY PARAMETER VALUES
export const SOFTWARE_DEVELOPMENT_TEAM_TYPE_QUERY_PARAM_VALUE = 'DEV';
export const TEMPLATE_CHOICE_KANBAN_QUERY_PARAM_VALUE = 'kanban';
